// Dialog Content
type DialogContentProps = {
  children: React.ReactNode;
  className?: string;
};

export function DialogContent({
  children,
  className = "",
}: DialogContentProps) {
  return (
    <div
      className={`bg-white h-full w-full md:w-4/5 flex flex-col justify-between overflow-y-auto relative  ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  );
}
